import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// components
import { PasscodeComponent } from '../../../components/passcode/passcode.component';

// modules
import { ShowSecretToggleModule } from '../show-secret-toggle/show-secret-toggle.module';

@NgModule({
  declarations: [PasscodeComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ShowSecretToggleModule,
  ],
  exports: [PasscodeComponent],
  providers: [],
})
export class PasscodeModule {}
